import en from "yup/lib/locale"
import id from "./id"
import vi from "./vi"
import es from "./es"

export {
  id,
  en,
  vi,
  es
}
